import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { forkJoin } from 'rxjs';
import { StatoPresaVisioneTimesheet, Timesheet } from '../../interfaces/timesheet.interface';
import { TimesheetService } from '../../service/timesheet.service';
import { RettificheService } from '../../service/rettifiche.service';
import { Rettifica } from '../../interfaces/rettifica.interface';

export const dettaglioRisorsaResolver: ResolveFn<{
  anagraficaTimeSheet: any;
  risorsa: Timesheet[];
  statoPresaVisioneTimesheet: StatoPresaVisioneTimesheet;
  richiesteModifica: Rettifica[];
  giorniModificati?: any;
}> = (route, state) => {
  const timesheetService = inject(TimesheetService);
  const rettificheService = inject(RettificheService);
  return forkJoin({
    anagraficaTimeSheet: timesheetService.getAnagraficaTimeSheet(),
    risorsa: timesheetService.getDettaglioRisorsa(),
    statoPresaVisioneTimesheet:
      timesheetService.getDettaglioStatoPresaVisioneTimesheet(),
    richiesteModifica: rettificheService.getModificheRisorsa(),
    giorniModificati: rettificheService.getGiorniModificheRisorsa(),
  });
};
